<template>
    <!-- Componente para mostrar todos los modelos disponibles en la sección de Modelos -->
    <div class="pb-4">
        <div class="w-full mx-auto my-8 px-6 flex justify-center items-center">
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'autos' }"
                @click="changeCategory('autos')"
            >
                Autos
            </div>
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'suv' }"
                @click="changeCategory('suv')"
            >
                SUV
            </div>
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'hibridos' }"
                @click="changeCategory('hibridos')"
            >
                Híbridos
            </div>
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'electricos' }"
                @click="changeCategory('electricos')"
            >
                Eléctricos
            </div>
            <!--
            <div
                class="mx-4 sm:mx-8 font-bold cursor-pointer hover:text-light-blue"
                :class="{ 'text-light-blue': activeCategory === 'especiales' }"
                @click="changeCategory('especiales')"
            >Especiales
            </div>
            -->
        </div>
        <div class="text-center mt-6 lg:mt-16 lg:mb-10">
            <h2 class="font-bold text-2xl lg:text-3xl">Todos los modelos</h2>
        </div>
        <div class="models mx-auto max-w-screen-xl">
            <div
                class="flex flex-wrap justify-center items-end md:content-around mb-12 lg:w-11/12 xl:w-full mx-auto"
                v-for="(category, key) in categories"
                :key="key"
                v-show="activeCategory === key"
                :class="'models-' + key"
            >
                <div
                    class="model w-5/6 sm:w-5/12 lg:w-3/12 mt-8 cursor-pointer"
                    v-for="(model, index) in category"
                    :key="model.id"
                    @click="onClickModel(model, index)"
                    :class="'model-' + index"
                    :id="'model-' + model.id"
                >
                    <figure class="w-full h-40 flex justify-center items-center">
                        <img class="w-full" :src="`${model.model_image}`" :alt="model.name" />
                    </figure>
                    <div class="ml-10 md:ml-12 leading-snug">
                        <p class="text-xl lg:text-lg font-medium">
                            {{ model.name }} <span class="font-sans">{{ model.year }}</span>
                        </p>
                        <p class="text-base lg:text-sm">Desde ${{ formatPrice(model.initial_price) }}</p>
                    </div>
                </div>
            </div>
            <model-detail
                :model="modelSelected"
                :active-category="activeCategory"
                class="model-detail hidden"
                @close-model-detail="closeModelDetail()"
            ></model-detail>
        </div>
    </div>
</template>

<script>
export default {
    props: ["categories"],
    data() {
        return {
            // Variable para almacenar la url base del sitio
            url: $(".url").text(),
            // Variable para seleccionar la categoría activa
            activeCategory: "autos",
            // Variable para almacenar el modelo seleccionado
            modelSelected: {},
        };
    },
    methods: {
        // Función para formatear el precio de los modelos
        formatPrice(price, n, x) {
            let re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
            return parseInt(price).toFixed(Math.max(0, ~~n)).replace(new RegExp(re, "g"), "$&,");
        },
        // Función para mostrar el detalle de un modelo
        // al hacer click en el mismo
        onClickModel(model, index) {
            const $modelDetail = $(".model-detail");
            $modelDetail.fadeOut("fast", () => {
                this.modelSelected = model;
                const $models = $(`.models-${this.activeCategory} .model`);
                const modelTop = $models.eq(index).position().top;
                let modelIndex = index;

                // Encuentra el índice del último modelo en la fila
                for (let i = index + 1, len = $models.length; i < len; i++) {
                    const nextModelTop = $models.eq(i).position().top;
                    if (modelTop !== nextModelTop) {
                        modelIndex = i - 1;
                        break;
                    } else if (i === len - 1) {
                        modelIndex = i;
                    }
                }

                $models.eq(modelIndex).after($modelDetail);
                $modelDetail.fadeIn("fast");
            });
            setTimeout(() => {
                $("html, body").animate({ scrollTop: $modelDetail.offset().top - 10 }, 500);
            }, 300);
        },
        // Función para cambiar la categoría seleccionada
        // por el usuario
        changeCategory(category) {
            $(".models").fadeOut("fast", () => {
                this.activeCategory = category;
                $(".models").fadeIn("fast");
            });
        },
        // Función para cerrar el detalle del modelo en cuestión
        closeModelDetail() {
            $(".model-detail").fadeOut("fast");
        },
    },
    mounted() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const category = urlParams.get("categoria");
        if (category != null) {
            this.changeCategory(category);
        }
    },
};
</script>

<style></style>
